export * from "./FigureAxisData";
export * from "./FigureAxisSettings";
export * from "./FigureData";
export * from "./FigureGroupData";
export * from "./FigureLegendData";
export * from "./FigureLegendSettings";
export * from "./FigureRegressionLineData";
export * from "./FigureRegressionLineSettings";
export * from "./FigureSettings";
export * from "./FigureTypeSettings";
export * from "./FigureVarData";
export * from "./FigureVarSettings";
